import { useGlobalContext } from '@honeycomb/data';
import { interjectResourceString } from '../../../utils/interjectResourceString';
/**
 * Custom hook that returns a customer rating summary message based on a given number of reviews.
 *
 * If there is exactly one review, a singular version of the message is returned.
 * For any other number of reviews, the plural version of the message is formatted with the review count.
 *
 * @param {number} numberOfReviews - The number of reviews.
 * @returns {string} - A message summarising the customer rating, appropriately pluralised based on the number of reviews.
 */
export const useHotelCustomerRatingSummary = (numberOfReviews) => {
    const { resourceStrings: { CUSTOMER_RATING_SUMMARY_SINGULAR, CUSTOMER_RATING_SUMMARY_PLURAL }, } = useGlobalContext();
    if (numberOfReviews === 1) {
        return CUSTOMER_RATING_SUMMARY_SINGULAR;
    }
    return interjectResourceString(CUSTOMER_RATING_SUMMARY_PLURAL, numberOfReviews);
};
